export default "/images/Logo-9T-Thick-Black.svg?68fc4dbc297d35046b7dde8833bc6b39";